import { showError, clearErrors } from '../../portal-shared';

const form = document.querySelector('.js-reset-form');
const emailInput = document.querySelector<HTMLInputElement>('.js-email-input');

if (form && emailInput) {
    form.addEventListener('submit', function (e) {
        const email = (emailInput.value || '').trim();
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        clearErrors();
        if (!email) {
            e.preventDefault();
            showError('Email cannot be blank.');
            emailInput.focus();
            return;
        }
        if (!emailRegex.test(email)) {
            e.preventDefault();
            showError('Please enter a valid email address.');
            emailInput.focus();
            return;
        }
    });
}

if (module.hot) { module.hot.accept(); }
